<template>
    <div class="page">
        <van-nav-bar
                left-text="返回"
                :title="$route.meta.title"
                @click-left="$comm.onClickLeft"
                v-show="$comm.titleShow()"  left-arrow
                fixed>
            <template #left>
                <span class="iconfont iconshang comm-rotate-270"></span>
                <span class="comm-return">返回</span>
            </template>
        </van-nav-bar>
        <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

        <van-tabs @click="onClick" v-model="active1">
            <van-tab title="个人用户">

            </van-tab>
            <van-tab title="单位用户">

            </van-tab>
        </van-tabs>

        <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 0">
            <van-cell-group title="用户信息">
                <van-field
                        readonly
                        required
                        clickable
                        :value="form.合同号"
                        label="合同号"
                        placeholder="请选择"
                        :rules="[{ required: true, message: '请选择' }]">
                    <template v-if="!$route.query.readonly" #button>
                        <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
                    </template>
                </van-field>
                <van-field
                        required
                        v-model="form.用户名称"
                        label="用户名称"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
                <van-field
                        required
                        v-model="form.通讯地址"
                        label="通讯地址"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
                <van-field
                        required
                        v-model="form.缴费方式"
                        label="缴费方式"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
            </van-cell-group>

            <van-cell-group title="新缴费信息">
                <field-picker-popup :inputValue="form.缴费银行" @getValue="onGetValue" key2="缴费银行" label="缴费银行" placeholder="请选择" :columns="缴费银行Columns" :required="true"></field-picker-popup>
                <van-field
                        v-model="form.银行账户名"
                        label="银行账户名"
                        placeholder="请输入"
                        :rules="[{ pattern: $patternId, message: '请输入' }]"/>
                <van-field
                        v-model="form.银行账号"
                        label="银行账号"
                        placeholder="请输入"/>
                <van-field
                        v-model="form.身份证号"
                        label="身份证号"
                        placeholder="请输入"
                        :rules="[{ pattern: $pattern, message: '请输入' }]"/>
                <van-field
                        :rules="[{ required: true, message: '请输入' }]"
                        v-model="form.手机号码"
                        label="手机号码"
                        placeholder="请输入"
                        @change="nameChange()"/>
            </van-cell-group>

            <van-cell-group title="证件资料上传">
                <van-field
                        :required="!isNameSame"
                        label="产权人身份证(上传正反面2张)"
                        :rules="[{
                        required: !isNameSame,
                        message: $idcardmsg                      }]">
                    <template #input>
                        <van-uploader
                                :deletable="!$route.query.readonly"
                                :show-upload="!$route.query.readonly"
                                multiple
                                v-model="uploaderMst"
                                :after-read="afterReadMaster"
                                @delete="onDeleteMaster"/>
                    </template>
                </van-field>
                <van-field name="uploaderOpt" label="其它资料">
                    <template #input>
                        <van-uploader
                                :deletable="!$route.query.readonly"
                                :show-upload="!$route.query.readonly"
                                multiple
                                v-model="uploaderOpt"
                                :after-read="afterReadOpt"
                                @delete="onDeleteOpt"/>
                    </template>
                </van-field>
            </van-cell-group>

            <van-cell-group title="申请人信息">
                <van-field
                        v-model="form.申请人类别"
                        center
                        clearable
                        label="申请人类别"
                        placeholder=""
                        readonly>
                    <template #button>
                        <van-button size="small" type="info" plain @click="onChanquanren" v-if="!chanquanren && active1 == 0">产权人</van-button>
                        <van-button size="small" type="info" v-if="chanquanren && active1 == 0">产权人</van-button>

                        <div class="horizontal-gap"></div>

                        <van-button size="small" type="info" plain @click="onShenqingren" v-if="!shenqingren && active1 == 0">申请人</van-button>
                        <van-button size="small" type="info" v-if="shenqingren && active1 == 0">申请人</van-button>
                    </template>
                </van-field>

                <van-field required v-model="form.预估月水量" label="姓名" placeholder="请输入" v-if="shenqingren && active1 == 0"/>
                <van-field required v-model="form.预估月水量" label="身份证号" placeholder="请输入" v-if="shenqingren && active1 == 0"/>
                <van-field required name="uploader" label="身份证照片" v-if="shenqingren && active1 == 0">
                    <template #input>
                        <van-uploader multiple :max-count="3" v-model="form.产权人证明" v-show="active1 == 0"/>
                    </template>
                </van-field>
                <van-field required v-model="form.预估月水量" label="电话号码" placeholder="请输入" v-if="shenqingren && active1 == 0"/>

                <van-field
                        required
                        :rules="[{ required: true, message: '请输入' }]"
                        v-model="form.手机号码"
                        label="手机号码"
                        placeholder="请输入"
                        @change="nameChange()"
                        v-show="active1 == 0"/>
                <van-field
                        required
                        v-model="form.短信验证"
                        center
                        clearable
                        label="短信验证"
                        placeholder="请输入">
                    <template #button>
                        <sms-btn :phone="form.opmobile"></sms-btn>
                    </template>
                </van-field>
            </van-cell-group>

            <yonghuxuzhi></yonghuxuzhi>

            <van-button block
                        type="info"
                        native-type="submit"
                        v-if="!$route.query.readonly">
                提交
            </van-button>
        </van-form>

        <van-form @submit="onSubmit" :validate-trigger="$trigger" v-show="active1 == 1">
            <van-cell-group title="用户信息">
                <van-field
                        readonly
                        required
                        clickable
                        :value="form.合同号"
                        label="合同号"
                        placeholder="请选择"
                        :rules="[{ required: true, message: '请选择' }]">
                    <template v-if="!$route.query.readonly" #button>
                        <van-button type="info" size="mini" native-type="button" @click="choiceClick()">选择</van-button>
                    </template>
                </van-field>
                <van-field
                        required
                        v-model="form.用户名称"
                        label="用户名称"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
                <van-field
                        required
                        v-model="form.通讯地址"
                        label="通讯地址"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
                <van-field
                        required
                        v-model="form.缴费方式"
                        label="缴费方式"
                        placeholder="请输入"
                        :rules="[{ required: true, message: '请输入' }]"/>
            </van-cell-group>

            <van-cell-group title="新缴费信息">
                <field-picker-popup :inputValue="form.缴费银行" @getValue="onGetValue" key2="缴费银行" label="缴费银行" placeholder="请选择" :columns="缴费银行Columns" :required="true"></field-picker-popup>
                <van-field
                        v-model="form.银行账户名"
                        label="银行账户名"
                        placeholder="请输入"
                        :rules="[{ pattern: $patternId, message: '请输入' }]"/>
                <van-field
                        v-model="form.扣费账号"
                        label="扣费账号"
                        placeholder="请输入"/>
            </van-cell-group>

            <van-cell-group title="证件资料上传">
                <van-field
                        :required="!isNameSame"
                        label="营业执照（统一社会信用代码）"
                        :rules="[{
                        required: !isNameSame,
                        message: $idcardmsg}]">
                    <template #input>
                        <van-uploader
                                :deletable="!$route.query.readonly"
                                :show-upload="!$route.query.readonly"
                                multiple
                                v-model="uploaderMst"
                                :after-read="afterReadMaster"
                                @delete="onDeleteMaster"/>
                    </template>
                </van-field>
                <van-field name="uploaderOpt" label="其它资料">
                    <template #input>
                        <van-uploader
                                :deletable="!$route.query.readonly"
                                :show-upload="!$route.query.readonly"
                                multiple
                                v-model="uploaderOpt"
                                :after-read="afterReadOpt"
                                @delete="onDeleteOpt"/>
                    </template>
                </van-field>
            </van-cell-group>

            <van-cell-group title="申请人信息">
                <van-field
                        required
                        v-model="form.名称"
                        label="名称"
                        placeholder="名称"
                        @change="nameChange()"
                        :rules="[{ required: true, message: '请输入用户名称' }]"
                        v-show="active1 == 1"/>
                <van-field
                        required
                        v-model="form.idenno"
                        label="身份证号"
                        placeholder="身份证号"
                        :rules="[{ pattern: $patternId, message: '请输入正确格式' }]"
                        v-show="active1 == 1"/>
                <van-field
                        :required="!isNameSame"
                        name="uploaderMst"
                        label="身份证照片"
                        :rules="[{
                        required: !isNameSame,
                        message: $idcardmsg}]"
                        v-show="active1 == 1">
                    <template #input>
                        <van-uploader
                                :deletable="!$route.query.readonly"
                                :show-upload="!$route.query.readonly"
                                multiple
                                v-model="uploaderMst"
                                :after-read="afterReadMaster"
                                @delete="onDeleteMaster"/>
                    </template>
                </van-field>
                <van-field
                        v-model="form.mobile"
                        label="电话号码"
                        placeholder="请输入"
                        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
                        v-show="active1 == 1"/>
                <van-field
                        required
                        :rules="[{ required: true, message: '请输入' }]"
                        v-model="form.手机号码"
                        label="手机号码"
                        placeholder="请输入"
                        @change="nameChange()"
                        v-show="active1 == 1"/>
                <van-field
                        required
                        v-model="form.短信验证"
                        center
                        clearable
                        label="短信验证"
                        placeholder="请输入">
                    <template #button>
                        <sms-btn :phone="form.opmobile"></sms-btn>
                    </template>
                </van-field>
            </van-cell-group>

            <yonghuxuzhi></yonghuxuzhi>

            <van-button block
                        type="info"
                        native-type="submit"
                        v-if="!$route.query.readonly">
                提交
            </van-button>
        </van-form>

        <van-popup
                v-model="popShow"
                class="form-pop">
            <user-select-pop :userList="userList" :isquery="0" @onSelectClick="onSelectClick"></user-select-pop>
        </van-popup>
    </div>
</template>

<script>
    import smsBtn from '@/components/smsBtn.vue'
    import UserSelectPop from '@/components/UserSelectPop.vue'

    export default {
        name: 'MeterTransferForm',
        components: {
            smsBtn,
            UserSelectPop
        },
        data() {
            let cuser_info = null
            if (localStorage.getItem('cuser_info')) {
                cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
            }
            return {
                active: 0,
                active1: 0,
                popShow: false,
                uploaderMst: [], // vant自带缩略图站位
                uploaderHs: [],
                uploaderOpt: [],
                masterUrls: [],
                hourseUrls: [],
                optUrls: [],
                message: '',
                radio: '1',
                form: {
                    bussno: '',
                    usernoold: '', // 原用户编号
                    addrold: '', // 原用户地址
                    fixaddr: '', // 装表地址
                    uname: '',
                    idenno: '',
                    tel: '',
                    mobile: '',
                    smscode: '',
                    operator: cuser_info ? cuser_info.uname : '',
                    opmobile: cuser_info ? cuser_info.mobile : '',
                    opidenno: '',
                    bank: '',
                    bankkeep: '',
                    remark: '',
                    attach: []
                },
                value: '',
                showPicker: false,
                userList: JSON.parse(localStorage.getItem('userList')),
                userInfo: {},
                isNameSame: false,

                chanquanren: true,
                shenqingren: false,
                缴费银行Columns: [{text: '缴费一', value: '缴费1'}, {text: '缴费二', value: '缴费2'}],
            }
        },
        mounted() {
            if (this.$route.query.busscode && this.$route.query.bussno) {
                this.$comm.getBussInfo(this.$route.query.busscode, this.$route.query.bussno).then(res => {
                    this.form = res
                    let result = this.$comm.analysisAttach(res)
                    this.uploaderMst = result.uploaderMst
                    this.uploaderHs = result.uploaderHs
                    this.uploaderOpt = result.uploaderOpt
                    this.masterUrls = result.masterUrls
                    this.hourseUrls = result.hourseUrls
                    this.optUrls = result.optUrls
                })
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === 'BusinessProgress') {
                to.meta.isUseCache = true
            }
            next()
        },
        methods: {
            onGetValue(key2, value) {
                this.form[key2] = value
            },
            onChanquanren() {
                this.chanquanren = true
                this.shenqingren = false
            },
            onShenqingren() {
                this.chanquanren = false
                this.shenqingren = true
            },
            onClick() {
            },
            onYonghuxuzhi() {
            },
            afterReadMaster(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileUpload, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.masterUrls.push(res.data)
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            afterReadHourse(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileUpload, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.hourseUrls.push(res.data)
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            afterReadOpt(file) {
                this.$loading('上传中...')
                this.$http.post(this.$api.fileUpload, {
                    fileext: this.$comm.extname(file.file.name),
                    base64: file.content
                }).then(res => {
                    this.$clear()
                    if (res.code === '000') {
                        this.optUrls.push(res.data)
                    } else {
                        this.$toast('上传失败')
                    }
                })
            },
            onDeleteMaster(file, detail) {
                this.masterUrls.splice(detail.index, 1)
            },
            onDeleteHourse(file, detail) {
                this.hourseUrls.splice(detail.index, 1)
            },
            onDeleteOpt(file, detail) {
                this.optUrls.splice(detail.index, 1)
            },
            onSelectClick(user) {
                this.popShow = false
                this.form.usernoold = user.userno
                // this.form.addrold = user.addr
                // this.form.fixaddr = user.fixaddr
                this.$comm.getUserInfo(this.form.usernoold).then(res => {
                    this.userInfo = res
                    this.form.addrold = res.yhdz
                    this.form.fixaddr = res.zbwz
                })
            },
            choiceClick() {
                this.popShow = true
            },
            nameChange() {
                // eslint-disable-next-line no-debugger
                // debugger
                if (this.form.uname === this.form.operator) {
                    this.isNameSame = true
                } else {
                    this.isNameSame = false
                }
            },
            onSubmit() {
                // if(this.form.name!==this.form.operator&&this.uploaderOpt.length===0){
                //   this.$toast('用户名称与联系人不一致，请上传联系人身份证')
                //   return
                // }else{
                //   this.isNameSame = true
                // }
                this.form.attach = this.$comm.getAttach(this.masterUrls, this.hourseUrls, this.optUrls, [])
                if (this.radio) { // 银行代扣保留
                    this.form.bankkeep = this.userInfo.sffs
                }
                this.$http.post(this.$api.personTransfer, this.form).then(res => {
                    if (res.code === '000') {
                        this.$router.push({
                            path: '/business/success',
                            query: {
                                title: this.$route.meta.title,
                                from: '业务办理'
                            }
                        })
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .meter-transfer-form {
        /deep/ .van-radio-group.van-radio-group--horizontal {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(33, 33, 33, 1);

            .van-radio--horizontal {
                margin-right: 0;
                margin-left: 4px;

                .van-radio__label {
                    margin-left: 2px;
                }
            }
        }

        .form-pop {
            width: 85%;
            height: 60%;
            border-radius: 4px;
            font-size: 12px;
        }
    }
</style>